import { defineComponent } from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
  name: "HeaderNavTop",

  props: {
    webSite: {
      type: String,
      required: true,
    },
  },
  components: {},
  setup() {
    return {};
  },
  template: html`
    <svg xmlns="http://www.w3.org/2000/svg" class="hidden">
        <symbol id="icon-phone" viewBox="0 0 100 100">
            <path class="cls-1" d="M27.2,77.59l-.76,0a29.46,29.46,0,0,1-2.3-2,28,28,0,0,1-3.85-4.77c4.53-3.11,9.08-6.55,13.54-10.23l1.5,2.28,1.12,1.73a3,3,0,0,0,2.65,1.29,5.16,5.16,0,0,0,3-1c2-1.46,8.34-7.12,12.09-10.64,3.47-3.61,9.28-9.92,10.82-12a4.89,4.89,0,0,0,1-3.69,2.79,2.79,0,0,0-1.24-1.9l-4-2.57c3.71-4.41,7.18-8.92,10.33-13.41a27.59,27.59,0,0,1,4.84,3.8,29,29,0,0,1,2,2.28C78.21,37.07,72.13,49.2,61.17,60,50.33,71.17,38,77.59,27.2,77.59Z" />
            <path class="cls-1" d="M71.13,21.26a27.73,27.73,0,0,1,4.35,3.49c.6.6,1.23,1.29,1.9,2.1C77.64,37.08,71.62,49,60.8,59.65c-10.74,11.08-23,17.44-33.6,17.44h-.58c-.82-.67-1.52-1.29-2.13-1.89A27.2,27.2,0,0,1,21,70.91c4.27-3,8.55-6.18,12.75-9.63l1.29,2,1,1.55a3.53,3.53,0,0,0,3.08,1.53,5.72,5.72,0,0,0,3.27-1.11C44.55,63.7,50.91,58,54.52,54.56l0,0,0,0c3.45-3.6,9.29-9.93,10.84-12.06a5.32,5.32,0,0,0,1-4.09A3.28,3.28,0,0,0,65,36.15l-3.57-2.27c3.48-4.15,6.74-8.39,9.72-12.62m-.28-1.35c-3.27,4.71-6.92,9.45-10.91,14.16a.74.74,0,0,0,.17.18L64.44,37c1.34.83,1.48,3.06.15,4.88-1.46,2-7.1,8.15-10.75,12-3.85,3.61-10,9.16-12,10.6a4.71,4.71,0,0,1-2.69.92,2.58,2.58,0,0,1-2.24-1.06C35.94,62.86,35,61.43,34.09,60a.72.72,0,0,0-.17-.18c-4.76,4-9.55,7.56-14.31,10.8a28.56,28.56,0,0,0,4.18,5.27,29.72,29.72,0,0,0,2.47,2.17l.94,0c9.49,0,22.16-5.2,34.32-17.75,12.4-12.2,17.21-24.64,16.85-33.86A29.59,29.59,0,0,0,76.18,24a28.23,28.23,0,0,0-5.33-4.13Z" />
        </symbol>
        <symbol id="icon-line" viewBox="0 0 100 100">
            <path class="cls-1" d="M83.26,47c0-14.88-14.92-27-33.26-27S16.74,32.12,16.74,47c0,13.34,11.83,24.51,27.82,26.63,1.08.23,2.55.71,2.93,1.64a6.76,6.76,0,0,1,.1,3s-.39,2.35-.47,2.85C47,82,46.45,84.41,50,82.91S69.15,71.63,76.13,63.6h0C81,58.32,83.26,53,83.26,47Zm-45,7.94a.65.65,0,0,1-.65.65H28.3a.67.67,0,0,1-.45-.18h0a.63.63,0,0,1-.18-.45h0V40.45a.65.65,0,0,1,.65-.64h2.33a.65.65,0,0,1,.65.64V52h6.34a.65.65,0,0,1,.65.65Zm5.62,0a.65.65,0,0,1-.65.65H40.91a.65.65,0,0,1-.65-.65V40.45a.65.65,0,0,1,.65-.64h2.33a.65.65,0,0,1,.65.64Zm16.06,0a.65.65,0,0,1-.65.65H57l-.17,0h0l0,0h0l0,0h-.05l0,0h0a.61.61,0,0,1-.16-.16l-6.65-9v8.6a.65.65,0,0,1-.65.65H46.81a.65.65,0,0,1-.65-.65V40.45a.65.65,0,0,1,.65-.64h2.57l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,.06,6.64,9V40.45a.65.65,0,0,1,.65-.64H59.3a.65.65,0,0,1,.65.64ZM72.83,42.79a.64.64,0,0,1-.65.64H65.84v2.45h6.34a.65.65,0,0,1,.65.65v2.33a.65.65,0,0,1-.65.65H65.84V52h6.34a.65.65,0,0,1,.65.65v2.33a.65.65,0,0,1-.65.65H62.86a.67.67,0,0,1-.45-.18h0a.6.6,0,0,1-.18-.45h0V40.45h0a.62.62,0,0,1,.17-.44h0a.67.67,0,0,1,.45-.18h9.32a.65.65,0,0,1,.65.64Z" />
        </symbol>
        <symbol id="icon-messenger" viewBox="0 0 100 100">
            <path class="cls-1" d="M51.13,19.24c-18.53,0-32.88,13.57-32.88,31.9A31.24,31.24,0,0,0,28.57,74.73a2.64,2.64,0,0,1,.89,1.87l.18,5.85a2.64,2.64,0,0,0,3.69,2.33l6.52-2.88a2.6,2.6,0,0,1,1.76-.13A36,36,0,0,0,51.13,83C69.65,83,84,69.46,84,51.14S69.65,19.24,51.13,19.24ZM70.87,43.79,61.22,59.1a5,5,0,0,1-7.14,1.32L46.4,54.66a2,2,0,0,0-2.37,0L33.65,62.54a1.56,1.56,0,0,1-2.26-2.08L41,45.14a5,5,0,0,1,7.14-1.31l7.68,5.76a2,2,0,0,0,2.37,0l10.38-7.87A1.56,1.56,0,0,1,70.87,43.79Z" />
        </symbol>
        <symbol id="icon-fb" viewBox="0 0 100 100">
            <path class="cls-2" d="M69.46,64.45,71.68,50H57.81V40.62c0-3.95,1.94-7.81,8.15-7.81h6.31V20.51a76.81,76.81,0,0,0-11.2-1c-11.42,0-18.88,6.92-18.88,19.45V50H29.49V64.45h12.7V99.39a50.3,50.3,0,0,0,15.62,0V64.45Z" />
        </symbol>
        <symbol id="icon-youtube" viewBox="0 0 100 100">
            <path class="cls-2" d="M80.36,41.57a27.47,27.47,0,0,0-.88-6.11,7.94,7.94,0,0,0-7.67-6.23c-7.23-.55-14.47-.56-21.7-.65-7.27.09-14.54.1-21.79.66a8.87,8.87,0,0,0-4.21,1.35c-2.73,1.78-3.46,4.61-3.85,7.53A104,104,0,0,0,19.68,54a56.59,56.59,0,0,0,.75,8.91,9.85,9.85,0,0,0,2.5,5.54c1.67,1.63,3.79,2.09,6,2.32,3.32.36,6.66.38,10,.47,11,.31,22,.27,33-.47a8.83,8.83,0,0,0,4.3-1.39c2.61-1.73,3.42-4.46,3.77-7.28A109.16,109.16,0,0,0,80.36,41.57ZM43.13,58.69V40l17.95,9.37Z" />
        </symbol>
        <symbol id="icon-share" viewBox="0 0 100 100">
            <circle class="cls-1" cx="65.36" cy="32.64" r="9.64" />
            <circle class="cls-1" cx="30.64" cy="50" r="9.64" />
            <circle class="cls-1" cx="65.36" cy="67.36" r="9.64" />
            <line class="cls-3" x1="30.64" y1="50" x2="65.36" y2="32.64" />
            <line class="cls-4" x1="30.64" y1="50" x2="65.36" y2="67.36" />
        </symbol>
        <symbol id="icon-contact" viewBox="0 0 100 100">
            <path class="cls-1" d="M94,52.51c-.13.49-.24,1-.39,1.48a8.68,8.68,0,0,1-8,6.09c-.6,0-1.19,0-1.89,0v1c0,4.41,0,8.82,0,13.23,0,.81-.14,1.51-1,1.81s-1.35-.14-1.86-.71q-3.25-3.6-6.53-7.19l-.76-.81a2.81,2.81,0,0,0-.15.43c-.62,5.23-4,8.26-9.27,8.28q-11.43,0-22.85.07a1.89,1.89,0,0,0-1.55.68q-6.5,7.2-13.05,14.37a5.83,5.83,0,0,1-.78.79,1.41,1.41,0,0,1-2.28-.84,4.26,4.26,0,0,1-.07-.94v-14h-1c-2.52,0-5,0-7.56,0A8.71,8.71,0,0,1,6,67.14V37c0-5.35,3.59-9,9-9.12,3.49-.06,7,0,10.48,0,.33,0,.67,0,1.1,0,0-1.54,0-3,0-4.39a30.16,30.16,0,0,1,.29-5.13A8.39,8.39,0,0,1,35,11.63q19.59,0,39.18.06c3.78,0,7.56,0,11.34.06a8.56,8.56,0,0,1,8.29,7c0,.19.1.38.16.57ZM26.53,87.1l.78-.83c3.62-4,7.26-8,10.85-12a2.84,2.84,0,0,1,2.31-1c7.94,0,15.87-.05,23.8-.09,3.77,0,6.23-2.29,6.25-5.92q0-15.33,0-30.67a5.7,5.7,0,0,0-6.06-5.93l-32.82,0q-8.25,0-16.5.06c-3.85,0-6.21,2.4-6.21,6.23q0,15.17,0,30.33a5.76,5.76,0,0,0,6,6c3.15,0,6.3,0,9.45,0,1.79,0,2.19.39,2.19,2.15V87.1Zm2.94-59.3h1.45c11.26,0,22.52-.05,33.77,0a9.56,9.56,0,0,1,3.26.61c3.51,1.3,5.52,4.49,5.52,8.58q0,12.54,0,25.09a2,2,0,0,0,.59,1.52c2,2.19,4,4.4,6,6.61a8.16,8.16,0,0,1,.5.66l.22-.13V59.15c0-1.5.49-2,2-2H85a5.75,5.75,0,0,0,6.11-6.06q0-15.21,0-30.42a7.32,7.32,0,0,0-.29-2c-.79-2.55-3-4-5.94-4l-33-.09-16.33,0a5.76,5.76,0,0,0-6,5.9c0,1.37,0,2.75,0,4.12Z" />
            <path class="cls-1" d="M39.78,51.21H58a8.23,8.23,0,0,1,.86,0,1.48,1.48,0,0,1,1.41,1.46,1.44,1.44,0,0,1-1.34,1.43,7.31,7.31,0,0,1-.94,0H21.47a5.14,5.14,0,0,1-1.11-.08,1.43,1.43,0,0,1,0-2.8,5,5,0,0,1,1-.06Z" />
            <path class="cls-1" d="M39.78,60h18.3c1.48,0,2.19.48,2.19,1.46S59.53,63,58.08,63H21.13c-1.24,0-1.9-.53-1.91-1.48S19.85,60,21.13,60Z" />
            <path class="cls-1" d="M30.14,45.33c-3,0-6.06,0-9.1,0a2.3,2.3,0,0,1-1.4-.45,1.39,1.39,0,0,1,.48-2.32A2.57,2.57,0,0,1,21,42.4H39.58a1.51,1.51,0,0,1,1.62,1.51,1.46,1.46,0,0,1-1.62,1.41c-2.89,0-5.78,0-8.67,0Z" />
        </symbol>
    </svg>
    <div class="header-nav-top">
      <div v-if="webSite === 'b2c'" class="online-service">
        <ul class="online-service-list">
          <li class="line">
            <a href="https://line.me/R/ti/p/%40bestwaytravel">
              <svg class="icon_24_24 online-service-icon">
                <use xlink:href="#icon-line" alt="LINE線上客服" />
              </svg>
              LINE線上客服
            </a>
          </li>
          <li class="messenger">
            <a href="https://m.facebook.com/messages/thread/456800857725204">
              <svg class="icon_24_24 online-service-icon">
                <use xlink:href="#icon-messenger" alt="messenger" />
              </svg>
              Messenger
            </a>
          </li>
          <li class="phone">
            <a href="/Company/Store">
              <svg class="icon_24_24 online-service-icon">
                <use xlink:href="#icon-phone" alt="撥打電話" />
              </svg>
              撥打電話
            </a>
          </li>
        </ul>
      </div>
    </div>
  `,
  styles: `
    .hidden {
      display: none;
    }

    .cls-3, .cls-4 {
      stroke: #fff;
      stroke-miterlimit: 10;
      stroke-width: 4px;
    }

    .icon_14_14 {
      width: 14px;
      height: 14px;
    }

    .icon_24_24 {
      width: 24px;
      height: 24px;
    }

    .icon_32_32 {
      width: 32px;
      height: 32px;
    }

    .icon_36_36 {
      width: 36px;
      height: 36px;
    }

    .icon_48_48 {
      width: 48px;
      height: 48px;
    }
  `,
});
